<template>
    <div class="t-filter-container">
        <div
            v-if="isMobile"
            class="t-btn _gray t-filter-container__btn"
            @click="toggleFiltersVisible"
        >
            <span>{{ nameBtn }}</span>
        </div>
        <filter-cmp
            @close="toggleFiltersVisible"
            :class="{show: isVisibleFilters}"
            :filter="filter"
            :form-name="formName"
            :is-filter-date="isFilterDate"
            :is-reset-filter="isResetFilter"
        >
        </filter-cmp>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import filter from '@components/ui-components/filter/filter.vue';

    export default {
        name: "filter-container",
        props: {
            filter: {
                type: Array,
                default: () => []
            },
            isFilterDate: {
                type: Boolean,
                default: true,
            },
            nameBtn: {
                type: String,
                default: 'Сортировать'
            },
            formName: {
                type: String,
                default: undefined
            },
            isResetFilter: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                filters: false,
            }
        },
        components: {
            'filter-cmp': filter,
        },
        computed: {
            ...mapState('mobile', ['isMobile']),
            isVisibleFilters() {
                return this.isMobile ? this.filters : true;
            },
        },
        methods: {
            toggleFiltersVisible() {
                this.filters = !this.filters;
            },
        }
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/templates/components/ui-components/filter-container/filter-container.vue